import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-navy text-gold">
                <div className="font-mono text-sm uppercase tracking-[0.3em]">Verifica sessione...</div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/admin/login" replace />;
    return children;
}
